import { render, staticRenderFns } from "./ITextFieldFunctional.vue?vue&type=template&id=5a480739&functional=true&"
import script from "./ITextFieldFunctional.vue?vue&type=script&lang=js&"
export * from "./ITextFieldFunctional.vue?vue&type=script&lang=js&"
import style0 from "./ITextFieldFunctional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports